import React from "react";
import { Link } from "../../../shared/components/Link/Link";
import { WatchOnAppleIcon } from "../../../shared/components/WatchOnAppleIcon/WatchOnAppleIcon";
import {
  StyledMatchDetails,
  StyledMatchWatchLive,
  StyledMatchWatchLiveButton,
  StyledMatchWatchLiveWrapper,
} from "./StyledMatchWatch";
import Chevron from "./Chevron";
import { useReactAppState } from "../../../shared/containers/utils";

export const MatchWatchLive = ({
  appleStreamURL = null,
  trackFn = () => null,
  forceLightVersion = false,
  showChevron = false,
  matchPageUrl,
}) => {
  const { t } = useReactAppState();

  const handleClick = () => {
    trackFn();
  };

  if (showChevron) {
    return <Chevron />;
  }

  return (
    <StyledMatchWatchLive forceLightVersion={forceLightVersion}>
      {appleStreamURL ? (
        <StyledMatchWatchLiveWrapper onClick={handleClick}>
          <Link url={appleStreamURL} target="_blank">
            <StyledMatchWatchLiveButton
              className="mls-c-match-list__match-watch-live-button"
              forceLightVersion={forceLightVersion}
            >
              <WatchOnAppleIcon width={80} height={12} />
            </StyledMatchWatchLiveButton>
          </Link>
        </StyledMatchWatchLiveWrapper>
      ) : (
        <StyledMatchDetails>
          <Link url={matchPageUrl}>{t("match_details")}</Link>
        </StyledMatchDetails>
      )}
    </StyledMatchWatchLive>
  );
};
